/**
 *
 * @Copyright 2024 UNLOCKIT DECENTRALIZATION, LDA
 * Development by VOID Software, SA
 *
 */

import { FunctionComponent, useRef } from 'react';

import { VariableSizeList } from 'react-window';
import PdfViewerWrapper from '../elements/pdfViewer/PdfViewerWrapper';

type BaseProps = unknown;

export const TermsAndConditionsScreen: FunctionComponent<BaseProps> = () => {
    const pdfPagesListRef = useRef<VariableSizeList>();

    return (
        <section id="terms-and-conditions-screen" className="terms-and-conditions-screen">
            <PdfViewerWrapper
                fileUrl="/docs/terms-and-conditions.pdf"
                pdfPagesListRef={pdfPagesListRef}
            />
        </section>
    );
};
